import { render, staticRenderFns } from "./EventContentV2.vue?vue&type=template&id=77fe84bc&scoped=true"
import script from "./EventContentV2.vue?vue&type=script&lang=js"
export * from "./EventContentV2.vue?vue&type=script&lang=js"
import style0 from "./EventContentV2.vue?vue&type=style&index=0&id=77fe84bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fe84bc",
  null
  
)

export default component.exports